<div id="errorBox" class="error-box-container hidden" [class.hidden]="!isVisible">
  <div class="error-box-title">{{title}}</div>
  <div class="error-box-content">
    @if (hasMoreAbove) {
      <button
        type="button"
        class="error-box-scroll-indicator error-box-scroll-indicator-up"
        aria-label="Hinweise eine Seite nach oben scrollen"
        title="Hinweise eine Seite nach oben scrollen"
        (click)="scrollHintsUp()"
        >
        <i class="dx-icon dx-icon-chevronup" aria-hidden="true"></i>
      </button>
    }
    <dx-scroll-view
      #messagesScrollView
      (onScroll)="updateScrollIndicator($event)"
      (onUpdated)="updateScrollIndicator($event)"
      >
      <div #messagesContent>
        @if (hint) {
          <p class="error-box-hint">{{hint}}</p>
        }
        @for (error of items; track error.key) {
          <div class="error-box-item" (click)="error.onClick('')">
            @if (error.type.toLowerCase() === 'fehler') {
              <div class="dx-icon-clear"></div>
            }
            @if (error.type.toLowerCase() === 'information') {
              <div class="dx-icon-info"></div>
            }
            @if (error.category !== undefined && error.category!== null && error.category.length > 0) {
              <div class="error-box-item-category">
              {{error.category}}</div>
            }
            {{error.message}}
          </div>
        }
      </div>
    </dx-scroll-view>
    @if (hasMoreBelow) {
      <button
        type="button"
        class="error-box-scroll-indicator"
        aria-label="Hinweise eine Seite nach unten scrollen"
        title="Hinweise eine Seite nach unten scrollen"
        (click)="scrollHintsDown()"
        >
        <i class="dx-icon dx-icon-chevrondown" aria-hidden="true"></i>
      </button>
    }
  </div>
</div>
